import type {
  FilterConditionPluginSpecification,
} from '../filter.plugin';
import {
  FilterConditionPluginImpl
} from '../filter.plugin';
import type {
  BdCondition,
} from '@bindoc-projects/condition-domain-lib';
import {
  BdContentCondition,
} from '@bindoc-projects/condition-domain-lib';
import { BdArrayUtil } from '@bindoc-projects/util-domain-lib';
import type { AysCodeResponse } from '@bindoc-projects/code-domain-lib';
import { AysCode } from '@bindoc-projects/code-domain-lib';

export const BD_ICD_CODE_CONTENT_CONDITION_ID = 'icdCode';
export const FilterConditionIcdCodePluginType: FilterConditionPluginSpecification<
  AysCode[],
  FilterConditionIcdCodeDto,
  BdIcdCodeContentCondition
> = {
  type: 'icdCode',
  category: 'case',
  displayName: { de: 'ICD-Ziffer' },
  sortingIndex: 10,
  occurrence: 'single',
  fromObject(
    obj: FilterConditionIcdCodeDto,
  ): FilterConditionPluginImpl<AysCode[]> {
    return new FilterConditionIcdCodePlugin(
        obj.codes.map((it) => AysCode.fromObject(it)),
      );
  },
  fromCondition(
    jsonObj: BdIcdCodeContentCondition,
  ): FilterConditionPluginImpl<AysCode[]> {
    return new FilterConditionIcdCodePlugin(
        (jsonObj.includes ?? []).map((it) => AysCode.fromObject(it)),
      );
  },
  newInstance(): FilterConditionPluginImpl<AysCode[]> {
    return new FilterConditionIcdCodePlugin([]);
  },
};

export class FilterConditionIcdCodePlugin extends FilterConditionPluginImpl<
  AysCode[],
  FilterConditionIcdCodeDto
> {
  public static override Specification: FilterConditionPluginSpecification<
    AysCode[],
    FilterConditionIcdCodeDto,
    BdIcdCodeContentCondition
  > = FilterConditionIcdCodePluginType;

  constructor(private codes: AysCode[]) {
    super(FilterConditionIcdCodePluginType.type);
  }

  clone(): FilterConditionIcdCodePlugin {
    return new FilterConditionIcdCodePlugin([
      ...this.codes.map((it) => it.clone()),
    ]);
  }

  override equals(other: FilterConditionIcdCodePlugin): boolean {
    return (
      super.equals(other) &&
      BdArrayUtil.equals(
        this.codes,
        other.codes,
        (a, b) => a.name === b.name && a.codingSystem === b.codingSystem,
      )
    );
  }

  override validationToText(): string {
    if (this.codes.length === 0) {
      return 'Mindestens eine ICD-Ziffer auswählen';
    } else {
      return '';
    }
  }

  toCondition(): BdCondition | null {
    return new BdIcdCodeContentCondition(this.codes, []);
  }

  toJSON(): FilterConditionIcdCodeDto | null {
    return {
      type: this.type,
      codes: this.codes,
    };
  }

  toText(): string | null {
    return 'ICD-Ziffer';
  }

  toValue(): AysCode[] {
    return this.codes;
  }
}

export class BdIcdCodeContentCondition extends BdContentCondition<AysCode> {
  constructor(includes: AysCode[], excludes: AysCode[]) {
    super(BD_ICD_CODE_CONTENT_CONDITION_ID, includes, excludes);
  }
}

interface FilterConditionIcdCodeDto {
  type: string;
  codes: AysCodeResponse[];
}
